import { MAKE, MODEL } from 'site-modules/shared/constants/allowed-inventory-request-params';

export function isMultiMMInitial(selectedFacets) {
  return (
    (selectedFacets && selectedFacets[MAKE] && selectedFacets[MAKE].length > 1) ||
    (selectedFacets && selectedFacets[MODEL] && selectedFacets[MODEL].length > 1)
  );
}
